import { app_generic_resources_ext_RowInterface, app_generic_resources_hdr_RowClass, app_generic_resources_hdr_RowInterface, app_generic_resource_line_RowClass, app_generic_resource_line_RowInterface } from '../../dbschema';
import {BaseContainerModel} from '../base-container.model';

export class AppGenericResourcesContainerModel extends BaseContainerModel {
  hdr: app_generic_resources_hdr_RowInterface = new app_generic_resources_hdr_RowClass();
  lineList: app_generic_resource_line_RowInterface[] = [];
  extList: app_generic_resources_ext_RowInterface[] = [];
}